import React from 'react';

/** Trademark and attribution disclaimer. Required because the page references
 *  Turo by name and shows the Reddit, Facebook, and Instagram marks as
 *  sourcing credits for the host quotes. */
const DisclaimerSection = () => (
  <section className="mpa-disclaimer" aria-label="Trademark disclaimer">
    <div className="mpa-disclaimer-inner">
      <h2 className="mpa-disclaimer-heading">Disclaimer</h2>
      <p className="mpa-disclaimer-text">
        Insurance products and related services are subject to eligibility, underwriting
        requirements, policy terms, conditions, limitations, and availability. Turo is a trademark
        of its respective owner. Rentid is not affiliated with, endorsed by, or sponsored by Turo.
        References to third-party marketplaces are for comparative and informational purposes only.
        Reddit, Facebook, and Instagram are trademarks of their respective owners, and Rentid is not
        affiliated with, endorsed by, or sponsored by them. Those names and logos appear only to
        identify the public platforms where the referenced host commentary was published. Host
        quotes shown on this page are paraphrased from publicly posted commentary and are not
        attributed to any individual.
      </p>
    </div>
  </section>
);

export default DisclaimerSection;
